/* eslint-disable import/no-webpack-loader-syntax */
export const React = require('expose-loader?exposes=React!react');
export const ReactDOM = require('expose-loader?exposes=ReactDOM!react-dom');
export const ReactDOMServer = require('expose-loader?exposes=ReactDOMServer!react-dom/server');
export const Travelhome = require('expose-loader?exposes=Travelhome!../src/components');
require('../src/helpers/initsentry');
require('../src/helpers/minisite');
